module.exports = __webpack_public_path__ + "static/media/male-50.d2b177b3.png";